import { defineStore } from 'pinia'
import { useConfigStoreWithOut } from './config'
import type { IMatchOrderBy } from '@/api/match/types/match'
import { store } from '@/store'
import { getLocalStorage, getSessionStorage, useStorage } from '@/hooks/system/useStorage'
import router from '@/router'
import { PageEnum } from '@/enums/pageEnum'
import { fetchAccessCheck, fetchUserBase, fetchUserConfig } from '@/api/user/user'
import { EGlobalConfig, EMatchOrderBykey, EOddsChange, EPay, TOKEN_KEY, USERCONFIG, updownKey } from '@/enums/cacheEnum'
import type { IUserConfig, IUserbase } from '@/api/user/types'
import { isTestMode } from '@/utils/env'
import type { EBetOddsChange } from '@/api/bet/types/bet'
import type { EBetPay } from '@/api/bet/types/reserveBet'
import { isOu, isOuLang } from '@/locales'

interface UserState {
  isLogin?: boolean
  account?: IUserbase
  /** 配置数据 */
  config?: IUserConfig
  /** 赔率偏好 */
  oddsChange?: EBetOddsChange
  /** 提前结算 */
  pay?: EBetPay
  /** 1 红升绿降, 2 绿升红降 */
  updown?: 1 | 2
  matchOrderBy?: IMatchOrderBy
  /** 登录已过期, 有这个标志时，暂不退出页面 */
  isLoginOut?: boolean
  /** 新人 显示提示弹窗 */
  showGuide?: boolean | null
}

export const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => ({
    isLogin: !!useStorage.ls.get(EGlobalConfig.token),
    account: null,
    config: getSessionStorage(USERCONFIG, {}) as unknown as IUserConfig,
    oddsChange: getLocalStorage(EOddsChange, 1) as unknown as EBetOddsChange,
    pay: getLocalStorage(EPay, 1) as unknown as EBetPay,
    updown: useStorage.ls.get(updownKey), // getLocalStorage(updownKey, 1) as unknown as UserState['updown'],
    matchOrderBy: getLocalStorage(EMatchOrderBykey, 1) as unknown as IMatchOrderBy,
    isLoginOut: false,
    showGuide: getLocalStorage('showGuide', false) as unknown as boolean,
  }),
  getters: {

  },
  actions: {
    async getAccountInfo() {
      const configStore = useConfigStoreWithOut()
      return fetchUserBase().then((res) => {
        this.setAccount(res)

        const { currencyId } = configStore

        // eslint-disable-next-line eqeqeq
        const cFind = res.cbs.some(e => e.cid == currencyId)
        if (!cFind) {
          configStore.setCurrencyId(res.currencyId)
        }
      })
    },

    async fetchAccessCheck() {
      return fetchAccessCheck().then((res) => {
        this.showGuide = res
      })
    },

    setUserConfig() {
      return new Promise((resolve) => {
        if (this.config) {
          resolve(this.config)
        }
        fetchUserConfig().then((res) => {
          resolve(res)
          this.config = res
          useStorage.ls.set(USERCONFIG, res)
        })
      })
    },
    setAccount(res) {
      this.account = res
    },
    setUpDown(updown) {
      this.updown = updown
      useStorage.ls.set(updownKey, updown)
    },
    /** 根据语言设置 默认 升降颜色 */
    setDefalutUpDown(reset?: boolean) {
      if (useStorage.ls.get(updownKey) && !reset) return
      if (isOu(useStorage.ls.get(EGlobalConfig.language))) {
        this.setUpDown(2)
      } else {
        this.setUpDown(1)
      }
    },
    /** 登出 */
    async loginOut() {
      useStorage.ls.set(EGlobalConfig.token, 'guestMode')
      // useStorage.ls.remove('pcAddress')
      // useStorage.ls.remove('noType')
      // useStorage.ls.remove('URL_PARAMS')
      useStorage.ss.clear()
      router.replace({ path: PageEnum.LOGINOUT })
      // if (isTestMode()) {
      //   location.href = 'http://ns.c.test-newsports.com/#/'
      // } else {
      //   router.push(PageEnum.BASE_LOGIN)
      // }
    },

    async building({ beginTime, endTime }) {
      router.replace({ path: PageEnum.BUILDING, query: { beginTime, endTime } })
    },
  },
})

// Need to be used outside the setup
export function useUserStoreWithOut() {
  return useUserStore(store)
}
